import { useEffect, useRef } from "react";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { Box, Typography } from "@mui/material";


Chart.register(ArcElement, Tooltip, Legend);

const VENDORS = [
    "Digio",
    "Experian",
    "Zoop",
    "Arya",
    "Transunion",
    "Finbox",
    "Razorpay",
    "Google",
    "Smsstriker",
];

const VENDOR_COLORS = {
    Digio: "#a8dadc",
    Experian: "#f1c0e8",
    Zoop: "#7cedb4",
    Arya: "#ffd6a5",
    Transunion: "#cdb4db",
    Finbox: "#ffadad",
    Razorpay: "#7ea4ef",
    Google: "#fdffb6",
    Smsstriker: "#bde0fe",
};

export default function VendorWisePieChart({ apiData }) {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);

    const pieData = apiData.map((item, index) => {
        const vendorName = item.vendor
            .replace(/_/g, " ")
            .replace(/pvt ltd/i, "")
            .trim();

        const matchedVendor =
            VENDORS.find(
                (v) => v.toLowerCase() === vendorName.toLowerCase()
            ) || "Others";

        return {
            id: index,
            value: item.totalCost,
            label: matchedVendor,
            color: VENDOR_COLORS[matchedVendor],
        };
    });

    const totalCost = apiData.reduce(
        (sum, item) => sum + item.totalCost,
        0
    );

    useEffect(() => {
        if (!chartRef.current) return;
if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const labels = pieData.map((item) => item.label);
        const data = pieData.map((item) => item.value);
        const backgroundColor = pieData.map((item) => item.color);

      
        const ctx = chartRef.current.getContext("2d");
        chartInstanceRef.current = new Chart(ctx, {
            type: "pie",
            data: {
                labels: labels,
                datasets: [
                    {
                        data: data,
                        backgroundColor: backgroundColor,
                        borderColor: "#ffffff",
                        borderWidth: 2,
                        hoverOffset: 8,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        titleColor: "#ffffff",
                        bodyColor: "#ffffff",
                        borderColor: "#ffffff",
                        borderWidth: 1,
                        padding: 12,
                        displayColors: true,
                        callbacks: {
                            label: function (context) {
                                const label = context.label || "";
                                const value = context.parsed || 0;
                                const percentage = ((value / totalCost) * 100).toFixed(1);
                                return `${label}: ₹${value.toLocaleString()} (${percentage}%)`;
                            },
                        },
                    },
                },
                layout: {
                    padding: 10,
                },
            },
        });

        // Cleanup function
        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [apiData]);

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                   marginTop:'12px'
                }}
            >
                <p style={{ fontFamily: 'Inter-Medium', color: '#667085', fontSize: '25px' }}>Vendor Wise Costing</p>
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "40px",
                }}
            >
                {/* Chart Container */}
                <Box
                    sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                        padding: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "120px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        marginTop: "40px",
                        width: "300px",
                        height: "300px",
                    }}
                >
                    <canvas ref={chartRef} width="350" height="350"></canvas>
                </Box>
             
                <Box>
                    {VENDORS.map((vendor) => (
                        <Box
                            key={vendor}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                mb: 1.2,
                                opacity: pieData.some((p) => p.label === vendor) ? 1 : 0.4,
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    transform: "translateX(4px)",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    backgroundColor: VENDOR_COLORS[vendor],
                                    borderRadius: "3px",
                                }}
                            />
                            <Typography variant="body2">{vendor}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>

    );
}